<template>
  <legal-page
    title="Política de Entrega"
    :intro="`${business.name} presta servicios de telecomunicaciones. A continuación se describe cómo se “entrega” el servicio pagado a través de este portal.`"
  >
    <div class="legal-sections">
      <legal-section
        step="01"
        title="Servicios digitales / recurrentes"
        icon="ZapIcon"
        variant="success"
      >
        <p>
          Los pagos realizados no corresponden a productos físicos con
          envío. Al confirmarse el pago, el monto se acredita
          <strong>de inmediato</strong> al balance de tu contrato, y
          la continuidad o reconexión de tu servicio se refleja según
          los tiempos operativos de la red.
        </p>
      </legal-section>

      <legal-section
        step="02"
        title="Instalación de equipos"
        icon="ToolIcon"
        variant="warning"
      >
        <p>
          Cuando la contratación incluya la instalación de equipos en
          el domicilio, esta se coordina con el cliente a través de
          Servicio al Cliente, dentro del área de cobertura de
          {{ business.name }}.
        </p>
      </legal-section>

      <legal-section
        step="03"
        title="Comprobante"
        icon="FileTextIcon"
        variant="info"
      >
        <p>
          Tras cada pago exitoso recibirás un comprobante por correo
          electrónico con el detalle de la transacción.
        </p>
      </legal-section>

      <legal-section
        step="04"
        title="Soporte"
        icon="HeadphonesIcon"
      >
        <p>
          Ante cualquier inconveniente con la aplicación de tu pago,
          contáctanos en
          <a :href="`mailto:${business.email}`">{{
            business.email
          }}</a>
          o <a :href="`tel:${business.phone}`">{{ business.phone }}</a>.
        </p>
      </legal-section>
    </div>
  </legal-page>
</template>

<script>
import business from "@/business"
import LegalPage from "./LegalPage.vue"
import LegalSection from "./LegalSection.vue"

export default {
  components: { LegalPage, LegalSection },
  data() {
    return { business }
  },
}
</script>
